import DunsContent from "./Content";
import DunsSummary from "./Summary";

export const DunsStep = {
  Content: DunsContent,
  Summary: DunsSummary
}